import { gql } from '@apollo/client';

export const DELETE_COURSE_COORDINATOR = gql`
  mutation delete_course_coordinator($where: course_coordinator_bool_exp!) {
    delete_course_coordinator(where: $where) {
      affected_rows
    }
  }
`;

export const INSERT_COURSE_COORDINATOR = gql`
  mutation insert_course_coordinator($objects: [course_coordinator_insert_input!]!) {
    insert_course_coordinator(objects: $objects) {
      affected_rows
    }
  }
`;
